import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c32ac64"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Payouts", -1))
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 0,
  class: "text-xs font-semibold"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs font-semibold"
}
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
const _hoisted_14 = { key: 8 }
const _hoisted_15 = { key: 9 }
const _hoisted_16 = { key: 10 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-4 font-semibold" }, "Profit", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-4 font-semibold" }, "Approve", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-4 font-semibold" }, "Reject", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-4 font-semibold" }, "Edit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_SelectSellerTeam = _resolveComponent("SelectSellerTeam")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _component_ProfitDialog = _resolveComponent("ProfitDialog")!
  const _component_ApproveDialog = _resolveComponent("ApproveDialog")!
  const _component_RejectDialog = _resolveComponent("RejectDialog")!
  const _component_EditNoteDialog = _resolveComponent("EditNoteDialog")!
  const _component_StoresDialog = _resolveComponent("StoresDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_filter_table, {
            class: "mx-1",
            onOnFilterCallback: _ctx.onFilterCallback,
            placeholder: "Bill Name"
          }, null, 8, ["onOnFilterCallback"]),
          _createVNode(_component_el_select, {
            placeholder: "Status",
            modelValue: _ctx.params.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.status) = $event)),
            clearable: "",
            filterable: "",
            class: "mx-1"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.status, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id,
                  clearable: ""
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_SelectSellerTeam, {
            modelValue: _ctx.params.sellerTeamId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.sellerTeamId) = $event)),
            class: "mx-1"
          }, null, 8, ["modelValue"])
        ]),
        _withDirectives(_createVNode(_component_el_table, {
          data: _ctx.documents,
          stripe: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: index,
                label: column.title,
                props: column.dataIndex,
                "min-width": column.minWidth
              }, {
                default: _withCtx((item) => [
                  (column.dataIndex == 'name' && item.row?.sellerTeam)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createVNode(_component_router_link, {
                          to: { path: `/ag/sellers/${item.row.sellerTeam.id}` }
                        }, {
                          default: _withCtx(({ href }) => [
                            _createVNode(_component_el_link, {
                              type: "primary",
                              href: href
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_4, _toDisplayString(item.row.sellerTeam.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["href"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'code' && item.row?.sellerTeam)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.row.sellerTeam.code), 1))
                    : _createCommentVNode("", true),
                  (
                column.dataIndex == 'payoutMethod' && item.row?.payoutMethod
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.methodName(item.row.payoutMethod.paymentType)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == '_account' && item.row?.payoutMethod)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        (item.row?.payoutMethod.paymentType == 'payoneer')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.onChangeCardNumber(item.row.payoutMethod.paymentValue)), 1))
                          : _createCommentVNode("", true),
                        (item.row?.payoutMethod.paymentType == 'creditcard')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("span", null, _toDisplayString(item.row.payoutMethod.paymentAttributes.accountName) + " /  ", 1),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.onChangeCardNumber(
                      item.row.payoutMethod.paymentAttributes.accountNumber
                    )) + " /  ", 1),
                              _createElementVNode("span", null, _toDisplayString(item.row.payoutMethod.paymentAttributes.bankName), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'createdDate' && item.row?.createdDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatTime(item.row.createdDate)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'status')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 5,
                        class: _normalizeClass({
                'text-green-600': item.row.status == 1,
                'text-red-600': item.row.status == 2,
              })
                      }, _toDisplayString(_ctx.statusName(item.row.status)), 3))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'billName')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.row.billName), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'amount')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " $" + _toDisplayString(item.row.amount), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'approvedDate')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatTime(item.row.approvedDate)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'note')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.row.note), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex == 'action')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createVNode(_component_el_dropdown, { size: "large" }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, {
                                  onClick: ($event: any) => (_ctx.openProfitDialog(item))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                (item.row.status == 0)
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.openApproveDialog(item.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_18
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (item.row.status == 0)
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.openRejectDialog(item.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_dropdown_item, {
                                  onClick: ($event: any) => (_ctx.openEditNoteDialog(item.row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              size: 20,
                              class: "font-bold",
                              color: "#000"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_MoreFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label", "props", "min-width"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data"]), [
          [_directive_loading, _ctx.isLoading]
        ]),
        _createVNode(_component_pagination, {
          total: _ctx.total,
          pagination: _ctx.params.page,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.page) = $event)),
          limit: _ctx.params.limit,
          "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.limit) = $event))
        }, null, 8, ["total", "pagination", "limit"])
      ]),
      _: 1
    }, 16),
    _createVNode(_component_ProfitDialog, { ref: "profitDialog" }, null, 512),
    _createVNode(_component_ApproveDialog, {
      ref: "approveDialog",
      methodName: _ctx.methodName,
      onSubmit: _ctx.setStatus
    }, null, 8, ["methodName", "onSubmit"]),
    _createVNode(_component_RejectDialog, {
      ref: "rejectDialog",
      onSubmit: _ctx.setStatus
    }, null, 8, ["onSubmit"]),
    _createVNode(_component_EditNoteDialog, {
      ref: "editNoteDialog",
      onReset: _ctx.fetchData
    }, null, 8, ["onReset"]),
    _createVNode(_component_StoresDialog, { ref: "storesDialog" }, null, 512)
  ], 64))
}